import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

const heroImage =
  'https://readdy.ai/api/search-image?query=A%20soft%20artistic%20editorial%20background%20of%20hanging%20streetwear%20garments%20on%20a%20wooden%20clothing%20rack%20with%20warm%20golden%20bokeh%20lights%20and%20pastel%20terracotta%20tones%2C%20dreamy%20shallow%20depth%20of%20field%2C%20premium%20boutique%20fashion%20aesthetic%2C%20clean%20airy%20atmosphere%2C%20high%20detail%2C%20elegant%20composition&width=1600&height=900&seq=usfans-hero-01&orientation=landscape&nocache=true';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[600px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src={heroImage}
        alt="USFans Spreadsheet — streetwear fashion products flat lay"
        title="USFans Spreadsheet streetwear products"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/60 to-white/80"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 border border-background-200 text-xs font-medium text-foreground-700 whitespace-nowrap">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          {t('hero.badge')}
        </span>

        <h1 className="mt-6 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
          {t('hero.title')}
        </h1>

        <p className="mt-5 text-base md:text-lg text-foreground-700 max-w-2xl mx-auto leading-relaxed">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-grid-line text-base"></i>
            {t('hero.ctaPrimary')}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-base"></i>
            {t('hero.ctaSecondary')}
          </a>
        </div>

        <p className="mt-6 text-xs text-foreground-600 whitespace-nowrap">{t('hero.trust')}</p>
      </div>
    </section>
  );
}